export const getPets = async () => {
  // TODO: Implement get pets logic
  return [];
};

export const getPetById = async (id) => {
  // TODO: Implement get pet by id logic
  return null;
};

export const createPet = async (petData) => {
  // TODO: Implement create pet logic
  console.log('Create pet:', petData);
};

export const updatePet = async (id, petData) => {
  // TODO: Implement update pet logic
  console.log('Update pet:', id, petData);
}; 